import request from "@/CommonDP/utils/request";
import { toQueryString, getToken } from "@/CommonDP/utils";
import { isDef } from "@/CommonDP/utils/common";
import globalParams from "@/CommonDP/utils/globalParams";

// 流程模块接口
export default {
  moveGroup(id, orderNum) {
    return request.post(`/flow/group/move/${id}/${orderNum}`);
  },

  moveFlow(id, orderNum) {
    return request.post(`/flowNew/move/${id}/${orderNum}`);
  },

  addCCUserIdList(params) {
    return request.post(`/flow/instance/ccUser/add`, params);
  },
  saveDraft(params) {
    return request.post(`/flow/draft/save`, params, { title: "表单存储中..." });
  },
  getDraftFlowDetail(businessId) {
    return request.get(`/flow/draft/detail?businessId=${businessId}`, { title: "草稿数据读取中..." });
  },
  delDraftFlow(businessType, businessId) {
    return request.post(`/flow/draft/delete?businessType=${businessType}&businessId=${businessId}`);
  },
  startDraftFlow(params) {
    return request.post(`/flow/draft/start`, params, { title: "表单存储中..." });
  },
  deleteCCUserIdList(params) {
    return request.post(`/flow/instance/ccUser/delete`, params);
  },
  // 查询表单设计得表单字段列表
  queryFormColumns(formId) {
    return request.get(`/dyn-form-design/queryFormColumns/${formId}`).then((res) => res);
  },
  // 左侧树
  getPersonChooseOrgTree(enterpriseId) {
    return request.get(`/org/tree?enterpriseId=${enterpriseId}`, { title: "部门加载中..." });
  },
  // 查询节点的加签节点
  queryNextTempNode(flowInstanceNodeId) {
    return request.get(`/flow/node/tmp/queryNextTmpNodeRelatedToThisNode?nodeId=${flowInstanceNodeId}`);
  },
  // 根据标签id获取人员
  queryTagUserList(params) {
    return request.post(`/sysTag/relation/users`, params, { title: "标签人员读取中..." });
  },
  // 加签
  addTempNode(params) {
    return request.post("/flow/node/tmp/add", params);
  },
  deleteTmpNode(flowNodeId) {
    return request.post(`/flow/node/tmp/delete?nodeId=${flowNodeId || ""}`);
  },
  queryCCUserIdList(flowInstanceId) {
    return request.get(`/flow/instance/ccUsers?flowInstanceId=${flowInstanceId}`);
  },
  // 获取上传 用的项目id
  getDocByEnterpriseId(enterpriseId) {
    return request.get(`/family/new/getFamilyDocByEnterpriseId?enterpriseId=${enterpriseId}`).then((res) => res);
  },

  // 右侧列表
  getPersonChooseOrgUser(params) {
    return request.post(`/org/users/resursive-page`, params);
  },
  // 列表
  query(enterpriseId) {
    return request.get(`/flow/flowGroup/query?enterpriseId=${enterpriseId}`);
  },
  queryGroupList(enterpriseId) {
    return request.get(`/flow/flowGroup/query?enterpriseId=${enterpriseId}`);
  },
  // 修改
  updateFlowGroup(params) {
    return request.post(`/flow/updateFlowGroup`, params);
  },
  // 删除
  deleteFlowGroup(params) {
    return request.get("/flow/deleteFlowGroup", { params });
  },
  // 删除
  delFlowGroup(id) {
    return request.get(`/flow/deleteFlowGroup?id=${id}`);
  },
  addFlowGroup(params) {
    return request.post("/flow/addFlowGroup", params);
  },
  addFlowDefinition(params) {
    return request.post("/flow/addFlowDefinition", params);
  },
  updateFlowDefinition(params, id) {
    return request.post("/flow/updateFlowDefinition?flowDefinitionId=" + id, params);
  },
  // 获得流程分组对应表单格式
  flowGroupFormGet(flowGroupFormDto) {
    return request.post("/flow/flowGroupForm/get", flowGroupFormDto);
  },
  // 流程名查阶段
  queryDefListByDefId(definitionId, prjId, formType) {
    return request.get(`/flow/queryDefListByDefId?definitionId=${definitionId}&prjId=${prjId}&formType=${formType}`);
  },
  // 获取项目的专业角色
  querySpecRoleTree(enterpriseId) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/flow/specRole/queryTree");
    if (isDef(newUrl)) {
      return request.get(`${newUrl}?enterpriseId=${enterpriseId}`);
    }
    return request.get(`/flow/specRole/queryTree?enterpriseId=${enterpriseId}`);
  },
  // 获取系统角色
  querySysRoleList(enterpriseId) {
    return request.get(`/flow/querySysRoleList?enterpriseId=${enterpriseId}`, { title: "数据读取中..." });
  },
  // 获取部门
  queryOrgList(enterpriseId, assigneeType) {
    return request.get(`/flow/queryOrgList?enterpriseId=${enterpriseId}&assigneeType=${assigneeType}`, { title: "人员加载中..." });
  },
  queryOrgListByKeyword(enterpriseId, keyword) {
    return request.get("/org/queryOrgListByKeyword?enterpriseId=" + enterpriseId + "&keyword=" + keyword, { title: "人员查询中..." });
  },

  // 人员组件_最新
  queryOrgListNewMember(params) {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/prj-person-plan/queryUserTree");
    if (isDef(newUrl)) {
      return request.get(`${newUrl}`, { params, title: "人员加载中..." });
    }
    return request.get(`/prj-person-plan/queryUserTree`, { params, title: "人员加载中..." });
  },
  // 人员组件搜索_最新
  queryOrgListNewMemberByKeyword(params) {
    return request.get(`/prj-person-plan/queryUserAndDeptTree`, { params, title: "人员搜索中..." });
  },

  // 人员组件_组织架构
  queryOrgListMember(params) {
    return request.get(`/flow/queryOrgList`, { params, title: "人员加载中..." });
  },
  // 人员组件搜索_组织架构
  queryOrgListMemberByKeyword(params) {
    return request.get("/org/queryOrgListByKeyword", { params, title: "人员查询中..." });
  },

  // 删除流程
  deleteFlowDefinition(id) {
    return request.post(`/flow/deleteFlowDefinition?id=` + id);
  },
  queryDefinitionCountSum(enterpriseId) {
    return request.post(`/flow/queryDefinitionCountSum?enterpriseId=${enterpriseId}`);
  },
  // 获取所有流程分组列表
  queryGroupInfoList(enterpriseId) {
    return request.get(`/flow/queryGroupInfoList?enterpriseId=${enterpriseId}`);
  },
  // 获取项目的流程分组列表
  queryGroupPrjList(enterpriseId, prjCategoryId, prjId) {
    return request.get(`/flow/group/prj/list?enterpriseId=${enterpriseId}&prjCategoryId=${prjCategoryId || ""}&prjId=${prjId}`);
  },
  // 流程详情
  flowDefinitionDetail(id) {
    return request.get("/flow/flowDefinitionDetail?id=" + id);
  },
  hasStartedFlow(id) {
    return request.get("/flow/hasStartedFlow?flowDefinitionId=" + id);
  },
  initFlowDefinition(id) {
    return request.get("/flow/initFlowDefinition?groupId=" + id);
  },
  getFlowGroupForm(params) {
    return request.post("/flow/getFlowGroupForm", params);
  },
  querySpecList(prjId = "") {
    return request.get(`/flow/querySpecList?prjId=` + prjId);
  },
  queryPrjAllSpec(prjId) {
    return request.get(`/project/getSpecList?prjId=${prjId}`);
  },
  // 我的提交 流程
  mySubmit(params, pageNo, pageSize) {
    return request.post(`/flow/workbench/mySubmit?pageSize=${pageSize}&pageNum=${pageNo}`, params);
  },
  // 我的审批 待处理
  myProcessing(params, pageNo, pageSize) {
    return request.post(`/flow/workbench/myProcessing?pageSize=${pageSize}&pageNum=${pageNo}`, params);
  },
  // 我的审批 已处理
  myProcessed(params, pageNo, pageSize) {
    return request.post(`/flow/workbench/myProcessed?pageSize=${pageSize}&pageNum=${pageNo}`, params);
  },
  // 我的审批 抄送我的
  cc(params, pageNo, pageSize) {
    return request.post(`/flow/workbench/cc?pageSize=${pageSize}&pageNum=${pageNo}`, params);
  },
  // 我的审批 草稿
  queryDraftPage(params, pageNo, pageSize) {
    return request.post(`/flow/workbench/queryDraftPage?pageSize=${pageSize}&pageNum=${pageNo}`, params);
  },

  deleteDraft(businessType, businessId) {
    return request.post(`/flow/draft/delete?businessType=${businessType}&businessId=${businessId}`);
  },

  myAllApproveList(params, pageNo, pageSize) {
    return request.post(`/flow/workbench/queryAllPage?pageSize=${pageSize}&pageNum=${pageNo}`, params);
  },

  // 已废弃。审批流程详情
  detail(flowBusinessId) {
    return request.get(`/flow/workbench/detail?flowBusinessId=${flowBusinessId}`);
  },

  // 审批流程详情
  queryInstanceNodes(flowInstanceId) {
    return request.get(`/flow/instance/nodes?flowInstanceId=${flowInstanceId}`);
  },

  queryNodeDef(flowInstanceNodeId) {
    return request.get(`/flow/instance/node/queryDef?nodeId=${flowInstanceNodeId}`);
  },

  // 申请人
  queryFlowBusinessUsers(enterpriseId) {
    return request.get(`/flow/queryFlowBusinessUsers?enterpriseId=${enterpriseId}`);
  },
  // 申请人下拉框
  applicant(flowDefinitionId, enterpriseId) {
    return request.get(`/flow/workbench/applicant?flowDefinitionId=${flowDefinitionId || ""}&enterpriseId=${enterpriseId || ""}`);
  },
  queryApplicantProjects(query) {
    return request.get(`/flow/business/queryProjects?` + toQueryString(query));
  },
  // 工作台,我的审批申请人下拉框
  workbenchApplicant(enterpriseId) {
    return request.get(`/flow/workbench/applicant?enterpriseId=${enterpriseId}`);
  },
  // 流程类型
  queryFlowDefinitions(enterpriseId) {
    return request.get(`/flow/queryFlowDefinitions?enterpriseId=${enterpriseId}`);
  },
  // 流程定义类型下拉框
  downList(enterpriseId) {
    return request.get(`/flowNew/downList?enterpriseId=${enterpriseId}`);
  },
  // 最近
  queryUseRecently(enterpriseId) {
    return request.get(`/flow/queryUseRecently?enterpriseId=${enterpriseId}`);
  },
  queryUserStatus(flowId) {
    return request.get("/flow/queryUserStatus?flowId=" + flowId);
  },
  // 指定项目角色审批
  queryRoleApproveUserList(params) {
    return request.post("/flow/queryRoleApproveUserList", params);
  },
  // 指定系统角色审批
  querySysRoleApproveUserList(params) {
    return request.post("/flow/querySysRoleApproveUserList", params);
  },
  // 指定部门 审批
  queryDeptApproveUserList(params) {
    return request.post("/flow/queryDeptApproveUserList", params);
  },
  // 根据专业获取对应角色
  queryDefListByAcceptSpecialty(params) {
    return request.post("/flow/queryDefListByAcceptSpecialty", params);
  },
  // 预览记录
  readFlowFile(params) {
    return request.post("/flow/readFlowFile", params);
  },
  // 下载判断原文件是否删除啊
  flowFileIsExit(fileId) {
    return request.get(`/flow/flowFileIsExit?fileId=${fileId}`);
  },
  // 接收专业获取所有的专业
  queryPrjAcceptSpecialtyList(prjId) {
    return request.get(`/flow/queryPrjAcceptSpecialtyList?prjId=` + prjId);
  },
  prjStageListByPrjId(prjId) {
    return request.get(`/prj-person-plan/prjStageListByPrjId/` + prjId);
  },
  // 查询项目子项列表
  getPrjChildListByPrjId(prjId) {
    return request.get(`/prj-person-plan/getPrjChildListByPrjId/${prjId}?category=0`);
  },

  // 新建流程
  addNewFlow(dto) {
    return request.post("/flowNew/add", dto);
  },
  // 低代码流程添加接口
  flowNewAdd(params) {
    return request.post(`/flowNew/lowercode/add`, params).then((res) => res);
  },
  // 已废弃：查询流程信息，请使用 queryFlowDef 替代
  getFlow(flowDefinitionId, type) {
    return request.get(`/flowNew/get?flowDefinitionId=${flowDefinitionId}&type=${type}`);
  },
  // 查询流程;type:0查看;1:编辑
  queryFlowDef(flowVersionId, flowDefinitionId, flowKey, queryForEdit) {
    return request.get(`/flowNew/get?flowVersionId=${flowVersionId || ""}&flowDefinitionId=${flowDefinitionId}&flowKey=${flowKey || ""}&type=${queryForEdit || 0}`, {
      title: "流程数据读取中..."
    });
  },
  convertToDrawDesignVersion(flowDefinitionVersionId) {
    return request.post("/flowNew/convertToDrawDesignVersion?flowDefinitionVersionId=" + flowDefinitionVersionId);
  },
  // 查询流程
  getFlowInstanceIdDef(flowInstanceId) {
    return request.get(`flow/queryDef?flowInstanceId=${flowInstanceId}`, { title: "流程数据读取中..." });
  },

  // 查询流程版本
  getVersionFlow(flowDefinitionId, type, version) {
    return request.get(`/flowNew/get?flowDefinitionId=${flowDefinitionId}&type=${type}&flowVersionId=${version}`);
  },
  // 查询流程业务详情
  queryFlowDetail(businessId) {
    return request.get(`/flow/business/${businessId}`);
  },
  // 修改流程
  updateFlow(dto) {
    return request.post("/flowNew/update", dto);
  },
  // 修改流程
  updateFlowchart(dto) {
    return request.post("/flowNew/lowerCode/updateFlow", dto);
  },
  // 查询列表
  getFlowlist(params) {
    return request.get("/flowNew/list", { params });
  },
  // 删除
  deleteFlow(dto) {
    return request.post("/flowNew/delete", dto);
  },
  // 管理员删除流程
  adminDeleteFlow(dto) {
    return request.post("/flow/flowInstance/adminDelete", dto);
  },
  // 撤回流程
  withdrawApproval(params) {
    return request.post("/flow/flowInstance/withdrawApproval", params);
  },
  // 管理员回退流程
  adminJumpBack(dto) {
    return request.post("/flow/flowInstance/adminJumpBack", dto);
  },
  // 管理员跳过流程
  adminJumpForward(dto) {
    return request.post("/flow/flowInstance/adminJumpForward", dto);
  },
  // 禁用
  disableFlow(dto) {
    return request.post("/flowNew/disable", dto);
  },
  // 启用
  enableFlow(dto) {
    return request.post("/flowNew/enable", dto);
  },
  // 移动
  move(dto) {
    return request.post("/flowNew/move", dto);
  },
  // 获取当前流程的所有版本
  getVersionList(flowDefinitionId) {
    return request.get(`/flowNew/version/list?flowDefinitionId=${flowDefinitionId}`);
  },
  // 设置为当前版本
  VersionSettings(dto) {
    return request.post("/flowNew/currentVersionId/update", dto);
  },
  setNowVersion(params) {
    return request.post("/flowNew/currentVersionId/update", params);
  },
  // 根据条件获取节点列表
  queryFlowNodeList(dto) {
    return request.post("/flow/node/list", dto, { title: "流程处理人查询中..." });
  },
  // 根据条件获取节点列表
  queryFlowNodeAllList(flowInstanceId) {
    return request.get(`/flow/instance/nodes/all?flowInstanceId=${flowInstanceId}`);
  },
  // 根据ID获取节点信息
  queryFlowNodeDetail(flowNodeDefId) {
    return request.get(`/flow/instance/node/detail?flowNodeDefId=${flowNodeDefId}`);
  },
  // 同意当前节点
  agree(dto) {
    return request.post("/flow/flowInstance/agree", dto);
  },
  // 拒绝当前节点
  rejectNodeFlow(dto) {
    return request.post("/flow/flowInstance/rejectNodeFlow", dto);
  },
  // 流程处理转交
  transfer(dto) {
    return request.post("/flow/flowInstance/transfer", dto);
  },
  // 发布
  release(dto) {
    return request.post("/flowNew/release", dto);
  },
  // 流程撤回
  withdraw(dto) {
    return request.post("/flow/flowInstance/withdraw", dto);
  },

  // 查询业务表单
  getBusinessForm(flowInstanceId) {
    return request.get(`/flow/business/get?flowInstanceId=${flowInstanceId}`, { title: "流程数据读取中..." });
  },
  // 发起流程业务
  addFlow(dto) {
    return request.post("/flow/add", dto, { title: "流程发布中..." });
  },
  // 流程再发起
  flowAgain(dto) {
    return request.post("/flow/reStart", dto);
  },
  restart(dto) {
    return request.post("/flow/reStart", dto);
  },
  // 用户流程终止
  terminationFlowInstance(params) {
    return request.post(`/flow/flowInstance/terminateMyFlow`, params);
  },
  // 管理员流程节点驳回
  rejectAdmin(params) {
    return request.post(`/flow/flowInstance/adminReject`, params);
  },
  // 管理员流程节点终止
  async terminationAdmin(params) {
    return request.post(`/flow/flowInstance/adminTerminate`, params);
  },
  // 恢复终止流程
  resumeTerminated(params) {
    return request.post(`/flow/flowInstance/resumeTerminated`, params);
  },
  // 管理员恢复终止流程
  adminResumeTerminated(params) {
    return request.post(`/flow/flowInstance/adminResumeTerminated`, params);
  },
  // 管理员通过当前流程节点
  async passNodeAdmin(params) {
    return request.post(`/flow/flowInstance/node/adminForceAgree`, params);
  },
  // 管理员通过流程
  async passAdmin(params) {
    return request.post(`/flow/flowInstance/adminForceAgreeFlow`, params);
  },
  // 通用的文件上传
  upload(file) {
    return request.post("/common/upload", file);
  },
  // 流程节点文件下载
  download(fileId) {
    return request.get(`/flow/download/${fileId}`);
  },
  // 根据节点Id获取NodeKey
  getNodeKey(flowInstanceNodeId) {
    return request.get(`/flow/getNodeKey?flowInstanceNodeId=${flowInstanceNodeId}`);
  },

  queryAssigneeStrategies() {
    // 自定义接口地址
    const newUrl = globalParams.get("url:/flowNew/assigneeStrategy/list");
    if (isDef(newUrl)) {
      return request.get(`${newUrl}`, { title: "字典数据请求中..." });
    }
    return request.get(`/flowNew/assigneeStrategy/list`, { title: "字典数据请求中..." });
  },

  // 动态增加审批人
  dynamicAddApprover(dto) {
    return request.post("/flow/node/addUsersToNode", dto);
  },

  // 获取流程分组信息
  getFormGroupList(enterpriseId) {
    return request.get(`/formGroup/list?enterpriseId=${enterpriseId}`);
  },
  // 表单分组添加
  formGroupAdd(dto) {
    return request.post("/formGroup/add", dto);
  },
  // 表单分组删除
  formGroupDelete(groupId, enterpriseId) {
    return request.post(`/formGroup/delete?groupId=${groupId}&enterpriseId=${enterpriseId}`);
  },
  // 表单分组更新
  formGroupUpdate(dto) {
    return request.post("/formGroup/update", dto);
  },
  // 分页查询表单列表
  getFormList(pageNum, pageSize, dto) {
    return request.post(`/form/definition/page?pageNum=${pageNum}&pageSize=${pageSize}`, dto);
  },
  // 启用表单
  openFormList(ids) {
    return request.post("/form/definition/enable", ids);
  },
  // 禁用表单
  stopFormList(ids) {
    return request.post("/form/definition/disable", ids);
  },
  // 移动表单
  moveFormList(params) {
    return request.post("/form/definition/move", params);
  },
  // 批量删除表单配置
  deleteFormList(ids) {
    return request.post("/form/definition/batchDelete", ids);
  },
  // 添加表单配置
  addFormConfig(dto) {
    return request.post("/form/definition/add", dto);
  },
  // 添加表单配置
  updateFormConfig(dto) {
    return request.post("/form/definition/update", dto);
  },
  // 查询表单创建人
  getFormCreateUser() {
    return request.get(`/form/definition/createUser/query`);
  },
  // 分页获取审批历史
  getHistoryList(pageNum, pageSize, dto) {
    return request.post(`/flow/approvalRecord/page?pageNum=${pageNum}&pageSize=${pageSize}`, dto);
  },
  // 一条流程的审批历史
  getFlowInstanceHistory(flowInstanceId) {
    return request.get(`/flow/instance/nodes/history?flowInstanceId=${flowInstanceId}`, { title: "流程审批历史请求中..." });
  },
  // 导出流程审批记录
  exportFlowApplicationHistory(dto) {
    return request({
      url: "/flow/export",
      data: dto,
      method: "POST",
      responseType: "blob"
    });
  },
  // 查询当前是否有未发布的草稿
  getIsExistDraft(flowDefinitionId) {
    return request.get(`/flowNew/getIsExistDraft?flowDefinitionId=${flowDefinitionId}`);
  },
  // 分组下的表单
  getListForm(enterpriseId, formType) {
    return request.get(`/formGroup/listForm?enterpriseId=${enterpriseId}&formType=${formType}`);
  },
  // 表单元素
  getElementList(formDefinitionId) {
    return request.get(`/form/definition/element/list?formDefinitionId=${formDefinitionId}`);
  },
  formCreateQuery(id) {
    return request.get(`/form/definition/mongo/detail/${id}`);
  },
  // 查询当前人对应的表单查看权限
  getFormElementPermissions(flowBusinessId, type) {
    return request.get(`/flow/getFormElementPermissions?flowBusinessId=${flowBusinessId}&type=${type}`);
  },
  // 表单数量统计
  getFormNum(enterpriseId) {
    return request.get(`/form/definition/count?enterpriseId=${enterpriseId}`);
  },

  queryDraft(businessType, businessId) {
    return request.get(`/flow/draft/query?businessType=${businessType || ""}&businessId=${businessId || ""}`).then((res) => res.data);
  },

  queryFlowDefCcList(flowDefinitionId, flowKey) {
    return request.get(`/flowNew/flowDefCc/list?flowDefinitionId=${flowDefinitionId || ""}&flowKey=${flowKey || ""}`);
  },
  // 获取流程状态
  getStatus(flowInstanceId) {
    return request.get(`/flow/getStatus?flowInstanceId=${flowInstanceId}`);
  },

  // 查看绑定状态
  queryFlowFileStatus(params) {
    return request.post("/flow/queryFlowFileStatus", params);
  },
  // 获取项目角色
  queryRoleListFlow(enterpriseId) {
    return request.get(`/flow/queryRoleList?enterpriseId=${enterpriseId}`);
  },
  // 查询标签关联的人或部门
  queryTagList(tagId, type) {
    return request.get(`/sysTag/relation/list?tagId=${tagId}&type=${type}`);
  },
  sysTagList(enterpriseId) {
    return request.get("/sysTag/list?enterpriseId=" + enterpriseId, { title: "标签列表查询中..." }).then((res) => res);
  },
  // 获取标签和用户
  getTagAndUser(enterpriseId) {
    return request.get(`/sysTag/listAndUsers?enterpriseId=${enterpriseId}`);
  },
  // 审批记录:申请人下拉框
  getApprovalRecordList(enterpriseId, flowDefinitionId) {
    return request.get(`/flow/approvalRecord/list?enterpriseId=${enterpriseId}&flowDefinitionId=${flowDefinitionId}`);
  },
  // 获取关联文件位置
  getAssociatedFileLocation(fileId) {
    return request.get(`/doc/navbar/0/${fileId}`);
  },
  // 查询项目成员
  getProjectUsers(prjId) {
    return request.get(`/project/getProjectUsers?projectId=${prjId}`);
  },
  viewList(prjID) {
    return request.get(`/project/getProjectDetails?projectId=${prjID}`);
  },

  testConditionExpr(json) {
    return request.post(`/flow/general/testConditionExpr`, json);
  },
  importSave(params) {
    return request.post(`/dynMeta/import/save`, params);
  },
  // 上传插件，操作手册
  manualUpload(folderId, params) {
    return request.post(`/doc/upload/EnterpriseDoc/${folderId}`, params);
  },
  templateDownload(tableName) {
    return process.env.VUE_APP_API + `/dynMeta/import/template/download?tableName=${tableName}&token=${getToken()}`;
  },
  queryEnterpriseIdhiddenFolder(enterpriseId) {
    return request.get(`/enterprise/doc/hiddenFolder/queryId?enterpriseId=${enterpriseId}`);
  },
  importDataRead(fileId) {
    return request.get(`/dyn-common/import/data/read?fileId=${fileId}`);
  },
  getColumnList(tableName) {
    return request.get(`/dynMeta-column/list?tableName=${tableName}`);
  },
  saveExcelData(params) {
    return request.post(`/dyn-common/import/data`, params);
  },
  prjPlanTaskFlowList(flowTempId, specId, prjId) {
    return request.get(`/prjPlanTask/flow/list?flowTempId=${flowTempId}&specId=${specId}&prjId=${prjId}`);
  },
  queryFlowByFlowKey(flowKey, enterpriseId) {
    return request.get(`/flow/queryFlowByFlowKey?flowKey=${flowKey}&enterpriseId=${enterpriseId}`);
  },

  checkCanStart(params) {
    return request.post(`/flow/flowInstance/checkCanStart`, params);
  },

  genQLExpr(json) {
    return request.post(`/dyn-expr/genQLExpr`, json);
  },

  getRestrictPeople(params) {
    return request.post(`/flow/node/change/assignee`, params);
  },

  recreateDesignFile(flowInstanceId, businessId) {
    return request.post(`/flowNew/archive/recreate?flowInstanceId=${flowInstanceId || ""}&businessId=${businessId || ""}`);
  },
  queryTzDepositFolderByDesignFile(fileID) {
    return request.get(`/doc/queryTzDepositFolderByDesignFile/${fileID}`);
  },
};
